import { OnboardingTrialStepsType, ClientFlags } from '@sdk/authentication/types';
/**
 * Supported steps are always based on current availableSteps.
 * If clientFlags has more steps or less steps they will get filtered / extended.
 */
export const getSupportedSteps = (
  clientFlags: ClientFlags,
  availableSteps: OnboardingTrialStepsType[]
) =>
  availableSteps.map((stepKey) => {
    const step = clientFlags[stepKey];
    return step ? step : { key: stepKey, completed: false };
  });
